/* global angular */

(function () {
    "use strict";

    var app = angular.module('app');

    app.controller('SwimlistCtrl', ['$scope', 'State', 'api', function ($scope, State, api) {

        var state = new State();
        var data = {
            limit: 5,
        };
        var model = {};

        var scope = {
            state: state,
            data: data,
            model: model            
        };

        angular.extend($scope, scope);

        function dataTraining() {
            api.data.training().then(function (response) {
                angular.extend(data, response.data);
            });
        }

        function swimlist() {
            api.training.swimlist().then(function (response) {
                data.swimlist = response.data;
                data.results = data.swimlist ? data.swimlist.slice(0) : [];
            });
        }
        function Init() {
            dataTraining();
            swimlist();
        }

        Init();

        $scope.$watch('model.target', function () {
            if (data.swimlist) {
                if (!model.target) {
                    data.results = data.swimlist ? data.swimlist.slice(0) : [];
                    return;
                }
                data.results = data.swimlist.filter(function (item) {
                    if (item.target.id === model.target.id) {
                        return true;
                    }
                });
            }
        });

        $scope.$on('onWishListChange', function () { swimlist(); });

        function select(array, callback) {
            var r = array.filter(callback);
            return r.length ? r[0] : {};
        }
        
    }]);

}());